<fs-sidenav [config]="sideNavConfig"></fs-sidenav>
<ng-template
  #system
  let-item="item">
  <div class="fs-row.justify-between full-width">
    System
    @if ((unacknowledgedLogCount$ | async); as count) {
      <fs-badge
        [size]="10"
        [color]="'#F30000'">
      </fs-badge>
    }
  </div>
</ng-template>
<ng-template
  #systemLogs
  let-item="item">
  <div class="fs-row.justify-between full-width">
    Logs
    @if ((unacknowledgedLogCount$ | async); as count) {
      <app-indicator></app-indicator>
    }
  </div>
</ng-template>